"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COAService = void 0;
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var COAService = (function () {
    function COAService(token, profileId) {
        this.baseUrl = process.env.EDULAR_CORE_API_BASE_URL;
        this.token = token;
        this.profileId = profileId;
    }
    COAService.prototype.getCOAValues = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/fin-aid-plan/cfp-settings/list");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Accept: "application/json",
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "x-profile-id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, {}, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, (0, lodash_1.get)(res, "data.data", [])];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    COAService.prototype.getCOATemplates = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/coa-templates/list");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Accept: "application/json",
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "x-profile-id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, params, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, (0, lodash_1.get)(res, "data.data", [])];
                    case 3:
                        error_2 = _a.sent();
                        console.log(error_2);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    return COAService;
}());
exports.COAService = COAService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ09BU2VydmljZS5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsic2VydmVyL3NlcnZpY2VzL0NPQVNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsZ0RBQXlCO0FBQ3pCLGlDQUEwQjtBQUUxQjtJQUlJLG9CQUFZLEtBQWEsRUFBRSxTQUEwQjtRQUQzQyxZQUFPLEdBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQyx3QkFBd0IsQ0FBQTtRQUVwRCxJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQTtRQUNsQixJQUFJLENBQUMsU0FBUyxHQUFHLFNBQVMsQ0FBQTtJQUM5QixDQUFDO0lBQ1ksaUNBQVksR0FBekI7Ozs7Ozt3QkFDVSxHQUFHLEdBQUcsVUFBRyxJQUFJLENBQUMsT0FBTyx1Q0FBb0MsQ0FBQTs7Ozt3QkFFckQsYUFBYSxHQUFHOzRCQUNsQixPQUFPLEVBQUU7Z0NBQ0wsTUFBTSxFQUFFLGtCQUFrQjtnQ0FDMUIsYUFBYSxFQUFFLGlCQUFVLElBQUksQ0FBQyxLQUFLLENBQUU7Z0NBQ3JDLGNBQWMsRUFBRSxrQkFBa0I7Z0NBQ2xDLGNBQWMsRUFBRSxJQUFJLENBQUMsU0FBUzs2QkFDakM7eUJBQ0osQ0FBQTt3QkFNVyxXQUFNLGVBQUssQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLEVBQUUsRUFBRSxhQUFhLENBQUMsRUFBQTs7d0JBQTlDLEdBQUcsR0FBRyxTQUF3Qzt3QkFDcEQsV0FBTyxJQUFBLFlBQUcsRUFBQyxHQUFHLEVBQUUsV0FBVyxFQUFFLEVBQUUsQ0FBQyxFQUFBOzs7d0JBRWhDLE9BQU8sQ0FBQyxHQUFHLENBQUMsT0FBSyxDQUFDLENBQUE7Ozs7OztLQUV6QjtJQUVZLG9DQUFlLEdBQTVCLFVBQTZCLE1BQU07Ozs7Ozt3QkFDekIsR0FBRyxHQUFHLFVBQUcsSUFBSSxDQUFDLE9BQU8sMkJBQXdCLENBQUE7Ozs7d0JBRXpDLGFBQWEsR0FBRzs0QkFDbEIsT0FBTyxFQUFFO2dDQUNMLE1BQU0sRUFBRSxrQkFBa0I7Z0NBQzFCLGFBQWEsRUFBRSxpQkFBVSxJQUFJLENBQUMsS0FBSyxDQUFFO2dDQUNyQyxjQUFjLEVBQUUsa0JBQWtCO2dDQUNsQyxjQUFjLEVBQUUsSUFBSSxDQUFDLFNBQVM7NkJBQ2pDO3lCQUNKLENBQUE7d0JBTVcsV0FBTSxlQUFLLENBQUMsSUFBSSxDQUFDLEdBQUcsRUFBRSxNQUFNLEVBQUUsYUFBYSxDQUFDLEVBQUE7O3dCQUFsRCxHQUFHLEdBQUcsU0FBNEM7d0JBQ3hELFdBQU8sSUFBQSxZQUFHLEVBQUMsR0FBRyxFQUFFLFdBQVcsRUFBRSxFQUFFLENBQUMsRUFBQTs7O3dCQUVoQyxPQUFPLENBQUMsR0FBRyxDQUFDLE9BQUssQ0FBQyxDQUFBOzs7Ozs7S0FFekI7SUFDTCxpQkFBQztBQUFELENBQUMsQUFyREQsSUFxREM7QUFyRFksZ0NBQVUifQ==